<template>
  <nav class="tc-nav">
    <router-link to="/timecard" class="tc-nav-item" :class="{ active: isExactActive('/timecard') }">
      <i class="fas fa-clock"></i>
      <span>打刻</span>
    </router-link>
    <router-link to="/timecard/list" class="tc-nav-item" :class="{ active: isActive('/timecard/list') }">
      <i class="fas fa-calendar-alt"></i>
      <span>一覧</span>
    </router-link>
    <router-link to="/timecard/user-info" class="tc-nav-item" :class="{ active: isActive('/timecard/user-info') }">
      <i class="fas fa-user-cog"></i>
      <span>設定</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: "MenuNavigationMobile",
  methods: {
    isExactActive(path) {
      return this.$route.path === path;
    },
    isActive(prefix) {
      return this.$route.path.startsWith(prefix);
    },
  },
};
</script>

<style scoped>
.tc-nav {
  display: flex;
  gap: 4px;
  background: #fff;
  border-radius: 12px;
  padding: 4px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  border: 1px solid #e2e8f0;
}

.tc-nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 10px 12px;
  border-radius: 10px;
  text-decoration: none;
  color: #718096;
  font-size: 11px;
  font-weight: 600;
  transition: all 0.15s ease;
}

.tc-nav-item i {
  font-size: 18px;
  margin-bottom: 2px;
}

.tc-nav-item:hover {
  background: #f0faf4;
  color: #049C4C;
  text-decoration: none;
}

.tc-nav-item.active {
  background: #049C4C;
  color: #fff;
}

/* Override router-link default active class */
.tc-nav-item.router-link-active:not(.active) {
  background: transparent;
  color: #718096;
}
</style>
